import React from 'react';
import { Box, Container, Grid, Typography, useTheme } from '@mui/material';

import AlembicLogo from '@/asset/clients/alembic.svg';
import BrigadeLogo from '@/asset/clients/brigade_svg.svg';
import EmbassyLogo from '@/asset/clients/embassy_svg.svg';
import LodhaLogo from '@/asset/clients/lodha.svg';
import ProvidentLogo from '@/asset/clients/provident.svg';
import SapLogo from '@/asset/clients/sap.svg';

export const ClientLogosSection: React.FC = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const clientLogos = [
    { name: 'Brigade Group', logo: BrigadeLogo },
    { name: 'SAP Labs India', logo: SapLogo },
    { name: 'Embassy Group', logo: EmbassyLogo },
    { name: 'Lodha Group', logo: LodhaLogo },
    { name: 'Provident Housing', logo: ProvidentLogo },
    { name: 'Alembic Group', logo: AlembicLogo },
  ];

  return (
    <Box
      sx={{
        py: { xs: 8, md: 10 },
        backgroundColor: theme.palette.background.default,
        borderBottom: `1px solid ${theme.palette.divider}`,
        transition: 'background-color 0.3s ease, border-color 0.3s ease',
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography
            variant="caption"
            sx={{
              color: theme.palette.text.secondary,
              fontWeight: 700,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              display: 'block',
              mb: 1,
            }}
          >
            CLIENT & PARTNER ECOSYSTEM
          </Typography>

          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '1.75rem', md: '2.5rem' },
              color: theme.palette.text.primary,
              fontFamily: "'BankGothic Md BT', 'BankGothic MD BT', 'Space Grotesk', sans-serif",
              fontWeight: 700,
              mb: 2,
            }}
          >
            Trusted by Industry Leaders
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: theme.palette.text.secondary,
              maxWidth: 640,
              mx: 'auto',
              fontSize: '1rem',
            }}
          >
            Leading developers, tech enterprises, and public infrastructure authorities trust Inverika for complex engineering execution.
          </Typography>
        </Box>

        <Grid container spacing={4} justifyContent="center" alignItems="center">
          {clientLogos.map((client, index) => (
            <Grid item xs={6} sm={4} md={2} key={index}>
              <Box
                sx={{
                  p: 2,
                  height: 90,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'transparent',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-3px)',
                    '& img': {
                      filter: isDark ? 'brightness(0) invert(1)' : 'brightness(0)',
                      opacity: 1,
                    },
                  },
                }}
              >
                <Box
                  component="img"
                  src={client.logo}
                  alt={client.name}
                  sx={{
                    maxHeight: 48,
                    maxWidth: '85%',
                    objectFit: 'contain',
                    filter: isDark
                      ? 'grayscale(100%) invert(0.75) contrast(1.1) opacity(0.65)'
                      : 'grayscale(100%) opacity(0.55)',
                    transition: 'all 0.3s ease',
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ClientLogosSection;
